import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { getPseudoID, getUuidV4, handleNumberOnly, validarCNPJ, validarCPFCNPJ } from "../../../utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { SeguroInterface } from "../../../interfaces";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";
import { addSeguro, removeSeguro } from "../../../features/manifestoSlice";
import Averbacao from "./Averbacao";
import { TypeRespSeguro } from "../../../lists";

const initialForm: SeguroInterface = {
    id: 0,
    cnpj: '',
    cpfcnpj: '',
    nApol: '',
    nAver: [],
    respSeg: 1,
    xSeg: '',
}

export default function Seguro() {
    const dispatch = useDispatch();
    const [form, setForm] = useState<SeguroInterface>(initialForm);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<number | string>(0);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [optional, setOpcional] = useState<boolean>(true)
    const listaSeguros = useSelector((state: RootState) => state.manifesto.manifesto.seg);

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(0);
    }

    const handleOpenModal = (id: number | string) => {
        setSelected(id);
        setShowModal(true);
    }

    const handleRemover = (id: number | string) => {
        dispatch(removeSeguro(id));
        setShowModal(false);
    }

    const validaPreenchimento = () => {
        if (form.cpfcnpj.trim() === "") {
            alerta('Informe o CPF/CNPJ');
            return false;
        }

        if (!validarCPFCNPJ(form.cpfcnpj.trim())) {
            alerta('CPF/CNPJ inválido');
            return false;
        }

        if (form.respSeg.toString() === "2") {
            if (form.xSeg.trim() === "") {
                alerta('Informe o nome da seguradora.');
                return false;
            }

            if (form.cnpj.trim() === "") {
                alerta('Informe o CNPJ');
                return false;
            }

            if (!validarCNPJ(form.cnpj.trim())) {
                alerta('CNPJ inválido');
                return false;
            }
        }

        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addSeguro({
                ...form,
                id: getUuidV4()
            }))
            setForm(initialForm);
        }
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useEffect(() => {
        if (form.respSeg.toString() === "1") {
            setOpcional(true)
        } else {
            setOpcional(false)
        }
    }, [form.respSeg])

    return (<>
        <Row className="mb-3">
            <Col md className="border-end">
                <Row className="mb-3 g-2">
                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>Responsável pelo Seguro</Form.Label>
                            <Form.Select name="respSeg" value={form.respSeg} onChange={handleChange}>
                                {TypeRespSeguro.map(x => (
                                    <option key={x.id} value={x.id}>{x.name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>CPF/CNPJ</Form.Label>
                            <Form.Control name="cpfcnpj" value={form.cpfcnpj} maxLength={14}
                                onChange={handleChange}
                                onKeyUp={handleNumberOnly} />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group>
                            <Form.Label>Número da Apólice</Form.Label>
                            <Form.Control name="nApol" value={form.nApol} maxLength={20}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-3 g-2">
                    <Col md>
                        <Form.Group>
                            <Form.Label>Nome Seguradora</Form.Label>
                            <Form.Control name="xSeg" value={form.xSeg} disabled={optional} maxLength={30}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>CNPJ</Form.Label>
                            <Form.Control name="cnpj" maxLength={14} value={form.cnpj} disabled={optional}
                                onChange={handleChange} onKeyUp={handleNumberOnly} />
                        </Form.Group>
                    </Col>
                    <Col md={'auto'} className="d-flex align-items-end">
                        <Button onClick={handleAdd} title="Adicionar um condutor a lista">
                            <FontAwesomeIcon icon={faPlus} /> Adicionar
                        </Button>
                    </Col>
                </Row>
            </Col>

            <Col md={5}>
                <Averbacao form={form} setForm={setForm} />
            </Col>
        </Row>

        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>#</th>
                    <th>CPF/CNPJ</th>
                    <th>Número Apolice</th>
                    <th>Nome Seguradora</th>
                    <th>CNPJ</th>
                </tr>
            </thead>
            <tbody>
                {listaSeguros?.map((item: SeguroInterface) => (
                    <tr key={item.id}>
                        <td className="text-center">
                            <a href="javasctipt:void(0)" className="text-danger"
                                onClick={() => handleOpenModal(item.id)}>
                                <FontAwesomeIcon icon={faTrash} />
                            </a>
                        </td>
                        <td>{item.cpfcnpj}</td>
                        <td>{item.nApol}</td>
                        <td>{item.xSeg}</td>
                        <td>{item.cnpj}</td>
                    </tr>
                ))}
            </tbody>
        </Table>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={''}
            id={selected}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}